import Image from "next/legacy/image";

import { caseStudyBasePath } from '@constants';

type CaseStudyData = {
  title?: string | null;
  industry?: string | null;
  developerName?: string | null;
  developerLogoImage?: string | null;
  buyerName?: string | null;
};

export const CaseStudyCard: React.FC<{
  title?: any; // TODO
  coverImage?: any; // TODO
  slug?: string | null;
  className?: string;
  caseStudyData?: CaseStudyData;
}> = ({ title, coverImage, caseStudyData, className, slug }) => {
  return (
    <div
      className={`overflow-hidden rounded-2xl bg-lightgray drop-shadow-xl ${
        className || ''
      }`}
    >
      <a href={`${caseStudyBasePath}/${slug}`}>
        <Image
          width={612}
          height={344}
          layout='responsive'
          sizes='(min-width: 768px) 328px, 100vw'
          objectFit='cover'
          alt={title}
          src={coverImage?.sourceUrl}
        />
      </a>
      <div className='p-4'>
        <a
          href={`${caseStudyBasePath}/${slug}`}
          className='mb-4 block text-center text-center text-lg font-bold text-primary hover:opacity-75'
        >
          {title}
        </a>

        {caseStudyData?.developerLogoImage ? (
          <div className='flex justify-center'>
            <Image
              width={340}
              height={40}
              objectFit='contain'
              alt={caseStudyData?.developerName || ''}
              src={caseStudyData?.developerLogoImage}
            />
          </div>
        ) : (
          <div className='h-[40px]' />
        )}

        <hr className='mx-1 my-4 text-secondary2' />
        {caseStudyData?.title && (
          <div className='mb-2 font-bold'>{caseStudyData.title}</div>
        )}
        {caseStudyData?.industry && (
          <div>発注会社の業界：{caseStudyData.industry}</div>
        )}
        {caseStudyData?.developerName && (
          <div>開発：{caseStudyData.developerName}</div>
        )}
        {caseStudyData?.buyerName && <div>発注：{caseStudyData.buyerName}</div>}
      </div>
    </div>
  );
};
